import React, {useState} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner} from "@fortawesome/free-solid-svg-icons";

const DeleteModal = ({isOpen, onCancel, onConfirm}) => {
	const [loading, setLoading] = useState(false);

	const handleDelete = async (e) => {
		e.preventDefault();
		setLoading(true);
		try {
			await onConfirm();
		} finally {
			setLoading(false);
		}
	}

	if (!isOpen) return null;

	return (
		<div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
			<div className="bg-white rounded-md shadow-lg w-96 max-w-full">
				<div className="flex justify-between items-center p-4 border-b">
					<h2 className="text-lg font-medium">Delete</h2>
					<button onClick={onCancel} className="text-gray-500 hover:text-gray-700">
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
							 stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
							<line x1="18" y1="6" x2="6" y2="18"></line>
							<line x1="6" y1="6" x2="18" y2="18"></line>
						</svg>
					</button>
				</div>

				<div className="p-6 flex items-center">
					<div className="bg-yellow-50 rounded-full p-2 mr-4">
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
							 stroke="#F59E0B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
							<circle cx="12" cy="12" r="10"></circle>
							<line x1="12" y1="8" x2="12" y2="12"></line>
							<line x1="12" y1="16" x2="12.01" y2="16"></line>
						</svg>
					</div>
					<p className="text-gray-700">Sure delete?</p>
				</div>

				<div className="flex justify-end p-4 space-x-2 border-t">
					<button
						onClick={onCancel}
						className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
					>
						Cancel
					</button>
					<button
						onClick={handleDelete}
						className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
						disabled={loading}
					>
						{loading ? (
							<>
								<FontAwesomeIcon icon={faSpinner} className="animate-spin mr-2"/>
								Loading...
							</>
						) : (
							"Delete"
						)}
					</button>
				</div>
			</div>
		</div>
	);
};

export default DeleteModal;
